import { render, staticRenderFns } from "./SinDesglosar.vue?vue&type=template&id=aa830c5e&scoped=true&"
import script from "./SinDesglosar.vue?vue&type=script&lang=js&"
export * from "./SinDesglosar.vue?vue&type=script&lang=js&"
import style0 from "./SinDesglosar.vue?vue&type=style&index=0&id=aa830c5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa830c5e",
  null
  
)

export default component.exports